import * as overrides from "@/graphql/override_queries";
import Amplify, { API, graphqlOperation } from "aws-amplify";

const logger = new Amplify.Logger("Notifications_api");

function isSet(value) {
  return value !== undefined && value !== "" && value !== null;
}

function _formatResponse(obj, key) {
  return {
    action: key,
    data: isSet(obj.data[key]) ? obj.data[key] : [],
    errors: isSet(obj.data[key]) ? [] : obj.errors,
  };
}

export async function fetchNotifications(owner, options = {}) {
  const { limit = 20, nextToken = null } = options;

  let payload = [];

  const input = {
    owner,
    sortDirection: "DESC",
    limit,
  };

  if (nextToken) {
    input.nextToken = nextToken;
  }

  await API.graphql(
    graphqlOperation(overrides.notificationsByOwnerCreatedAt, input)
  )
    .then((res) => {
      logger.info(res);
      payload = _formatResponse(res, "notificationsByOwnerCreatedAt");
    })
    .catch((e) => {
      logger.info(e);
      payload = _formatResponse(e, "notificationsByOwnerCreatedAt");
    });

  return payload;
}

export async function fetchUnreadCount(owner) {
  let count = 0;

  const input = {
    owner,
    isRead: { eq: "false" },
    limit: 100,
  };

  try {
    let nextToken = null;
    do {
      if (nextToken) input.nextToken = nextToken;

      const res = await API.graphql(
        graphqlOperation(overrides.notificationsByOwnerReadStatus, input)
      );

      const data = res.data.notificationsByOwnerReadStatus;
      count += (data.items || []).length;
      nextToken = data.nextToken;
    } while (nextToken);
  } catch (e) {
    logger.info("Error fetching unread count:", e);
  }

  return count;
}

export async function markAsRead(notificationId) {
  let payload = {};

  const input = {
    id: notificationId,
    isRead: "true",
  };

  await API.graphql(
    graphqlOperation(overrides.updateNotification, { input })
  )
    .then((res) => {
      logger.info(res);
      payload = _formatResponse(res, "updateNotification");
    })
    .catch((e) => {
      logger.info(e);
      payload = _formatResponse(e, "updateNotification");
    });

  return payload;
}

export async function markAllAsRead(notificationIds) {
  const results = await Promise.all(
    notificationIds.map((id) => markAsRead(id))
  );
  return results;
}
